export const formatMessageRichTextOptions = () => {
  return {
    br: <br />,
    i: (chunks: React.ReactNode) => <i>{chunks}</i>,
  }
}
